import { Routes, RouterModule } from "@angular/router"
import { ErroresComponent } from "./errores.component"
export const routes: Routes = [{ path: "errores", component: ErroresComponent }]
export const erroresProviders = []

export const routing = RouterModule.forChild(routes)
